import { Image, Text, View, StyleSheet } from '@react-pdf/renderer'
import React from 'react'

const Header = () => {
    const styles = StyleSheet.create({
        header: {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignContent: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
        },  
        logo: {
            width: 100,
            height: 43,
        },
        status: {
            border: "1px",
            borderColor: "#000",
            height: "50px",
            width: "200px",
            backgroundColor: "#be1622",
            justifyContent: "center",
            alignItems: "center",
            color: "white"
        },
    });

    return (

        <View
            style={styles.header}
        >
            <Image
                style={styles.logo}
                src="/images/logo.png"
            />
            <View style={styles.status}>
                <Text style={{ fontSize: "18px", fontWeight: "bold", textTransform: "uppercase" }}>
                    Rejected
                </Text>
            </View>
        </View>
    )
}

export default Header